import axiosInstance from 'api/axiosInstance';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';
import { toParkingLocationPayload } from 'containers/pages/CANparkAdmin/utils/toParkingLocationPayload';

export const updateParkingLocation = async (
	parkingLocation: ParkingLocation,
): Promise<void> => {
	try {
		const API_URL = `/api2.0/parkingLocations/updateParkingLocation`;
		const response = await axiosInstance.post(
			API_URL,
			toParkingLocationPayload(parkingLocation),
			{
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);
		if (response.status !== 200) {
			console.error('Failed to update parking location:', response);
			throw new Error('Failed to update parking location');
		}
	} catch (error) {
		console.error('Error updating parking lot:', error);
		throw error;
	}
};
